import { useEffect, useState } from 'react';

function useClientSide() {
  const [isClientSide, setClientSide] = useState(false);

  useEffect(() => {
    setClientSide(true);
  }, []);

  return isClientSide;
}

export default useClientSide;
